import { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { getWebMetricsScriptUrl } from "../../../selectors/selectors";
import State from "../../../store/state";

export type WebMetricsProps = {
  webMetricsScriptUrl: string;
  reportOnRoute: string;
};

let skipLoad = false;

export const WebMetrics = ({ webMetricsScriptUrl, reportOnRoute }: WebMetricsProps): null => {
  const location = useLocation();

  if (location.pathname !== reportOnRoute) {
    skipLoad = true;
  }

  useEffect(() => {
    if (skipLoad) {
      return;
    }

    const script = document.createElement('script');
    const head = document.getElementsByTagName("head")[0];

    script.defer = true;
    script.src = webMetricsScriptUrl;
    head.appendChild(script);
    skipLoad = true;
  });

  return null;
}

const mapStateToProps = (state: State) => ({
  webMetricsScriptUrl: getWebMetricsScriptUrl(state),
});

export const resetWebMetricsLoad = () => {
  skipLoad = false;
}

export default connect(mapStateToProps)(WebMetrics);
